<template>
  <div
    class="table-saved-filters f-column"
    style="min-height: 0"
  >
    <div
      class="d-flex f-wrap no-scroll-track"
      style="overflow: auto; gap: 0.75rem"
    >
      <div class="d-flex">
        <GwFilter
          v-if="!tcrud_trulySelectedItems.length"
          style="max-width: 24.5rem"
          :asRow="true"
          :hasSaveBtn="false"
          :hasControls="false"
          :hasClearBtn="false"
          filterUrlPrefix="ffts"
          filterConfigKey="savedTrees"
        />
      </div>

      <div
        class="d-flex f-wrap ml-auto"
        style="gap: 0.5rem"
      >
        <div
          v-if="hasPresetModes"
          class="f-center mb-auto text-medium weight_500 clr-grey gw_hvr"
        >
          <GwTooltip
            class="mr-1 gw_hvr_content"
            style="--hvr-content-opacity: 0.5"
            :tooltip="$t('solfigr.apply_betsize_only_tooltip')"
          />
          {{ $tc('common.apply_xxx') }}
          <GwBtns
            class="ml-2"
            :options="[
              { id: 'restore_all', mode: 'restoreall' },
              { id: 'restore_betsizes_only', mode: 'restorebetsizesonly' },
            ]"
            idKey="mode"
            :value="solfigrPresetMode"
            style="
              background: var(--clr-black-1-3);
              border-radius: 4px;
              --gwbtn-padding: 0 0.5rem;
              --gwbtns-padding: 2px;
            "
            @click="(_e, item) => (solfigrPresetMode = item.mode)"
          >
            <template #default="{ item }">
              {{ $t(`solfigr.${item.id}`) }}
            </template>
          </GwBtns>
        </div>
        <div
          class="gw_btn text-medium csst csst_nm"
          style="--height: 2em"
          @click="openImportSettingDialog()"
          @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
        >
          <i
            class="mdi mdi-tray-arrow-down text-normal line-height_1"
            style="position: relative"
          ></i>
          <div
            class="csst_content text-nowrap"
            style="position: fixed"
          >
            {{ $t('common.import_setting') }}
          </div>
        </div>
      </div>
    </div>

    <TableBody
      ref="tablebody"
      class="gw_table_small gw_table_simple mt-2"
      style="--clr-back-body: var(--clr-black-0-3)"
      :items="tcrud_items"
      :loading="tcrud_loading"
      :error="tcrud_error"
      :isInfinite="true"
      size="small"
      keyField="id"
    >
      <template #no_data>
        <div
          class="gw_box flex-1 f-center"
          style="--clr-box-back: var(--clr-black-0-3)"
        >
          <IconAndText
            v-if="filter.active"
            class="my-auto"
            icon="mdi-filter"
            :title="$t('data_table.saved_trees.no_items')"
            :subtitle="$t('data_table.saved_trees.no_data')"
          />
          <IconAndText
            v-else
            class="my-auto"
            icon="mdi-cog"
            :title="$t('data_table.saved_trees.no_items')"
            :subtitle="$t('data_table.saved_trees.no_items_sub')"
          />
        </div>
      </template>
      <template #default="{ item, index }">
        <SavedTreesTableV1Row
          :hasOverwrite="hasOverwrite"
          :thead="thead"
          :item="item"
          tagType="saved_trees"
          :allTags="allTags"
          :mobile="mobile"
          :index="index"
          :isSelected="!!tcrud_selectedItems[index]"
          :isActive="selectedSavedTree ? selectedSavedTree.id === item.id : false"
          :draggedItems="tcrud_draggedItems"
          :dragDisabled="tbl_sortConf.sortKey !== 'ordering_position'"
          @apply:item="applyTree(item)"
          @open:detail="openSaveTreeDialog(item)"
          @click:tag_item="tag => tcrud_handleTagClick({ item, tag })"
          @drag:start="e => tcrud_handleDragstart({ e, item })"
          @delete:item="tcrud_deleteItem(item)"
          @overwrite:item="applyOverwrite(item)"
        >
        </SavedTreesTableV1Row>
      </template>
    </TableBody>

    <DragDropHandler
      ref="dragdrophandler"
      :getIndicatorStyle="tcrud_getDragIndicatorStyle"
      :proccessEvent="tcrud_scrollTable"
      dropTargetIdPart="saved-trees_table_row"
      @drag:drop="tcrud_handleDragdrop"
    >
      <template #shallowitem>
        <div
          class="gw_box"
          style="--clr-box-back: var(--clr-primary)"
        >
          <div
            v-if="tcrud_draggedItems.length > 1"
            class="truncate"
          >
            {{
              $t('common.xxx_selected_items', {
                num: tcrud_draggedItems.length,
              })
            }}
          </div>
          <div v-else-if="tcrud_draggedItem">
            {{ tcrud_draggedItem.name }}
          </div>
        </div>
      </template>
      <template #dropindicator>
        <div style="height: 1px; background: var(--clr-primary); width: 100%"></div>
      </template>
    </DragDropHandler>
  </div>
</template>

<script>
import IconAndText from '@/components/Poker/Overlays/IconAndText'
import GwBtns from '@/components/lib/GwBtns'
import GwTooltip from '@/components/lib/GwTooltip'
import GwFilter from '@/components/DataTables/Filters/new/GwFilter'
import { getTagFilteredTableData } from '@/store/tableFilters/tableFilters'
import { SNK } from '@/helpers/helpers'

import TableBody from '@/components/DataTables/v2/TableBody'
import DragDropHandler from '@/components/lib/DragDropHandler'

import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'
import tcrud_mix from '@/components/DataTables/tcrud_mix'
import SavedTreesTableV1Row from '@/components/DataTables/v2/tables/SavedTreesTableV1/SavedTreesTableV1Row'

export default {
  name: 'SavedTreesTableV1',
  components: {
    TableBody,
    SavedTreesTableV1Row,
    DragDropHandler,
    IconAndText,
    GwBtns,
    GwTooltip,
    GwFilter,
  },
  mixins: [tcrud_mix, table_mix, float_mix],
  props: {
    namespace: { type: String, required: true },
    hasTitle: { type: Boolean, default: true },
    selectedSavedTree: Object,
    hasPresetModes: Boolean,
    hasOverwrite: Boolean,
  },
  data() {
    // only changes that include tournament_data need to go throu v4
    this.tcrud_conf = {
      getEndpoint: item => `poker/custom-solutions/custom-trees/saved-trees/${item.id}/`,
      getDeleteEndpoint: item => `poker/custom-solutions/custom-trees/saved-trees/${item.id}/`,
      deleteSuccessMessage: 'messages.sucess_deleting_trees',
      deleteErrorMessage: 'messages.error_deleting_trees',
      idKey: 'id',
    }

    this.tbl_persistSortKey = 'customtrees_sort'
    this.tcrud_endpoint = 'poker/custom-solutions/custom-trees/saved-trees/'
    this.tcrud_mutation = 'api_poker_saved_trees_table'
    this.tcrud_apiVersion = 'v1'
    return {
      tbl_sortConf: {
        sortKey: 'ordering_position',
        sortOrder: 'asc',
      },
      selectedRows: [],
      lastTouchedIdx: -1,
      detailItem: null,

      tcrud_limit: 9999,
      tcrud_offset: 0,

      solfigrPresetMode: 'restoreall',
    }
  },
  created() {
    this.tbl_setSortConf()
    this.tcrud_getDataCheck()
  },
  methods: {
    openImportSettingDialog() {
      this.$store.dispatch('router_set_dialogs', 'import-solfigr-tree-dialog')
    },
    openSaveTreeDialog(item) {
      let newTree = {
        id: item.id,
        name: item.name,
      }
      this.$store.commit(`${this.namespace}/slfrm_set`, {
        key: 'slfrm_selectedTree',
        value: newTree,
      })
      this.$store.dispatch(
        'router_set_dialogs',
        `solfigr-save-tree-dialog_namespace-${this.namespace}`,
      )
    },
    applyOverwrite(item) {
      let preset = { ...this.$store.getters[SNK('slfrm_selectedTree', this.namespace)] }
      let data = {
        ...preset,
        name: item.name,
      }

      this.$store.dispatch('api_poker_custom_user_trees_set', {
        hasMessage: true,
        data,
        method: 'put',
        id: item.id,
        action: SNK('slfrm_handleApiTreeUpdate', this.namespace),
        actionArgs: {
          namespace: this.namespace,
          method: 'patch',
          dialogs: ['solfigr-save-tree-dialog', 'solfigr-saved-trees-dialog'],
        },
      })
    },
    applyTree(item) {
      this.$emit('apply:tree', { item, solfigrPresetMode: this.solfigrPresetMode })
    },
    patchItem({ item, description, name }) {
      if (name.length > 200) return
      if (description.length > 500) return
      name = name.trim()
      description = description.trim()
      let expected_item = {
        ...item,
        name,
        description,
      }
      this.tcrud_patchItem({
        item,
        patchData: {
          name,
          description,
        },
        expected_item,
      })
      this.detailItem = null
    },
  },
  computed: {
    allTags() {
      return this.$store.getters.tags_get_all_tags('saved_trees')
    },
    thead() {
      let cols = {
        name_description: {
          name: this.$t('table_head.name'),
          sortKey: 'name',
          width: 16,
        },
        tags: {
          name: this.$t('table_head.tags'),
          width: 27,
        },
        actions: {
          name: '',
          minWidth: 1.75,
        },
      }
      let res = {}
      Object.keys(cols).forEach(key => {
        let col = cols[key]
        let width = col.width || col.minWidth
        res[key] = {
          ...col,
          cssStyle: !width
            ? ''
            : `
            --min-width-th: ${width}rem;
            ${col.minWidth ? '' : `--max-width-th: ${width}rem`};
            `,
          tdStyle: !width
            ? ''
            : `
            --min-width-td: ${width}rem;
            ${col.minWidth ? '' : `--max-width-td: ${width}rem`};
            `,
        }
      })
      // console.log(res)
      return res
    },
    tcrud_apiData() {
      return this.$store.getters.api_get_data(this.tcrud_mutation)
    },
    tcrud_itemsDrag() {
      let res = (this.tcrud_apiData?.results || []).map(i => i)
      let { sortKey } = this.tbl_sortConf
      res.sort((a, b) => (a[sortKey] < b[sortKey] ? -1 : 1))
      return res
    },
    tcrud_items() {
      let res = (this.tcrud_apiData?.results || []).map(i => i) // map it so infinite does not fuck up

      res = getTagFilteredTableData({
        items: res,
        allTags: this.allTags,
        tagIds: this.filter.filter?.tags || [],
        anyall: this.filter.filter?.tags_anyall,
      })

      const { sortKey, sortOrder } = this.tbl_sortConf
      if (sortOrder === 'desc') {
        res.sort((a, b) => (a[sortKey] > b[sortKey] ? -1 : 1))
      } else {
        res.sort((a, b) => (a[sortKey] < b[sortKey] ? -1 : 1))
      }
      // res = [...res, ...res, ...res]
      // res = [...res, ...res, ...res]
      // res = [...res, ...res, ...res]
      // res = res.map((i, idx) => ({ ...i, id: idx }))
      // return []
      return res
    },
    tcrud_hasNext() {
      return !!this.tcrud_apiData?.links?.next
    },
    tcrud_apiCall() {
      return this.$store.getters.api_get(this.tcrud_mutation)
    },
    tcrud_loading() {
      return this.tcrud_apiCall?.loading
    },
    tcrud_loaded() {
      return this.tcrud_apiCall?.loaded
    },
    tcrud_status() {
      return this.tcrud_apiCall?.status
    },
    tcrud_error() {
      return this.tcrud_apiCall?.error
    },
    filter() {
      return this.$store.getters.ffts
    },
    tcrud_params() {
      return {
        limit: this.tcrud_limit,
        offset: this.tcrud_offset,
      }
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    globals_action() {
      return this.$store.getters.globals_action
    },
    loadingNewCustomSolution() {
      return this.$store.getters.api_get('api_poker_custom_user_trees').loading
    },
  },
  watch: {
    globals_action(a) {
      if (a === 'SavedTreesTableV1') {
        this.tcrud_getData()
        this.$store.dispatch('globals_action', '')
      }
    },
    tcrud_loaded() {
      this.$emit('update:loaded', {
        items: this.tcrud_items,
        status: this.tcrud_status,
      })
    },
  },
}
</script>
